import { useState } from "react";
import { Table } from "@mui/material"
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from "@tanstack/react-query";
import { getVendorEnquirySummary } from "../../api/enquiries";
import { MdOutlineArrowLeft, MdOutlineArrowRight } from "react-icons/md";
import DynamicSVG from "../../components/dashboard/venue-table/dynmaic-svg";
import { useNavigate } from "react-router-dom";
import { Seach, Filter } from "../../svgs";
import moment from "moment/moment";

const filterValue = ["All", "vendorName", "email"];

export default function Enquiries(){
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("All");
  const [dropdownFilter, setDropdownFilter] = useState(false);
  const navigate = useNavigate();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["vendorEnquirySummaryData", currentPage, itemsPerPage, searchQuery, filter],
    queryFn: async () => {
      return await getVendorEnquirySummary(currentPage, itemsPerPage, searchQuery, filter);
    },
    refetchOnWindowFocus: false,
  });

  const filteredData = (data?.data || []).filter((item) => {
    const searchLower = searchQuery.toLowerCase();
    
    if (filter === "All") {
      return Object.values(item).some(value => 
        String(value).toLowerCase().includes(searchLower)
      );
    } else {
      return String(item[filter]).toLowerCase().includes(searchLower);
    }
  });

  const totalEnquiriesCell = item => {
    return (
      <div className="flex items-center">
        <span className="text-blue-500 underline font-bold cursor-pointer" onClick={() => navigate(`/vendor-enquiries/${item?.vendorId}`)}>{item?.totalEnquiries}</span>
      </div>
    )
  }

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center justify-start space-x-4 lg:px-5 lg:w-2/5">
          <div className="relative">
            <button
              className="bg-primary flex gap-2 items-center text-white rounded-lg py-3 px-5 border"
              onClick={() => setDropdownFilter(!dropdownFilter)}
            >
              <Filter /> {filter === "All" ? "Filter" : filter}
            </button>
            {dropdownFilter && (
              <div className="absolute right-0 z-30 mt-2 w-32 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg ring-1 flex flex-col gap-2 focus:outline-none">
                {filterValue.map((item, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      setFilter(item);
                      setDropdownFilter(false);
                    }}
                    className="py-3 px-4 text-left hover:bg-gray-100"
                  >
                    {item}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="relative border-borderShade border rounded-lg text-secondary h-full lg:w-1/2 w-full">
            <span className="absolute inset-y-0 grid w-10 place-content-center">
              <button
                type="button"
                className="text-gray-600 hover:text-gray-700"
              >
                <span className="sr-only">Search</span>
                <Seach />
              </button>
            </span>
            <input
              type="text"
              id="Search"
              placeholder="Search for..."
              className="w-full rounded-md focus:outline-none ps-16 text-sm"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>SNo</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>     
              <TableCell>Number of Venues</TableCell>      
              <TableCell>Total Enquiries</TableCell>
              <TableCell>Last Enquiry Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              filteredData?.map((enquiry, index) => {
                return (
                  <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <DynamicSVG
                          index={index}
                          currentPage={currentPage}
                          itemsPerPage={itemsPerPage}
                        />
                      </TableCell>
                      <TableCell>{enquiry?.vendorName}</TableCell>
                      <TableCell>{enquiry?.email}</TableCell>   
                      <TableCell>{enquiry?.totalVenues}</TableCell>           
                      <TableCell align="center">{totalEnquiriesCell(enquiry)}</TableCell>
                      <TableCell>{enquiry?.lastEnquiryDate ? moment(enquiry?.lastEnquiryDate).format("DD/MM/YYYY") : "-"}</TableCell>
                    </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
         <div className="flex justify-center items-center relative bottom-0 gap-5 ">
          <span className="text-black">Page</span>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setCurrentPage((prev) => prev - 1)}
              disabled={currentPage === 1}
              className={`disabled:opacity-50 ${
                currentPage === 1 ? "cursor-not-allowed" : ""
              }`}
            >
              <MdOutlineArrowLeft className="text-primary text-3xl" />
            </button>
            <div className="min-w-[24px] h-[24px] flex bg-primary text-white justify-center items-center rounded-full">
              {currentPage}
            </div>
            <button
              onClick={() => setCurrentPage((prev) => prev + 1)}
              disabled={currentPage === Math.ceil(data?.total / itemsPerPage)}
              className={`py-2 px-4 disabled:opacity-50 ${
                currentPage === data?.total ? "cursor-not-allowed" : ""
              }`}
            >
              <MdOutlineArrowRight className="text-primary text-3xl" />
            </button>
          </div>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setCurrentPage(1);
              setItemsPerPage(parseInt(e.target.value, 10));
            }}
            className="py-2 bg-white border-b border-blue-200 rounded"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </select>
        </div>
      </TableContainer> 
    </div>
  )
}